"use client";

import React from "react";
import { Building2, Users, Factory, Award } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const metrics = [{
  id: "1",
  value: "47+",
  label: "Años de Operación",
  icon: Building2
}, {
  id: "2",
  value: "500+",
  label: "Colaboradores",
  icon: Users
}, {
  id: "3",
  value: "9+",
  label: "Sedes Globales",
  icon: Factory
}, {
  id: "4",
  value: "100+",
  label: "Clientes Principales",
  icon: Award
}];
export default function CompanyStatistics() {
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="253743" id="company-statistics" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        {}
        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8 transition-all duration-1000 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {metrics.map((metric, i) => <div key={metric.id} data-index={i} className="flex flex-col items-center text-center space-y-4" style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="p-4 bg-primary/10 rounded-lg text-primary mb-2 shadow-sm">
                <metric.icon className="w-8 h-8" strokeWidth={1.5} />
              </div>
              <h3 className="text-5xl lg:text-6xl font-bold text-primary font-default tracking-tighter">
                {metric.value}
              </h3>
              <p className="text-foreground font-semibold text-lg font-default">
                {metric.label}
              </p>
            </div>)}
        </div>

        {}
        <div ref={headerRef} className={`mt-24 md:mt-32 flex flex-col items-center text-center transition-all duration-1000 delay-300 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-primary font-default mb-4">
            Excelencia Industrial Certificada
          </h2>
          <div className="flex items-center gap-1.5 mb-6">
            <div className="h-0.5 w-16 bg-accent rounded-md"></div>
            <div className="h-0.5 w-4 bg-secondary rounded-md"></div>
          </div>
          <p className="text-muted-foreground max-w-2xl text-base md:text-lg font-default">
            Nuestra trayectoria está respaldada por estándares internacionales y un compromiso inquebrantable con la calidad en cada proceso.
          </p>
        </div>
      </div>
    </section>;
}